<template>
  <div class="main">
    <div class="top_back">
      <DivTop :active='5' />
      <div class="w120 bj_box">
        <span>第三方资源中心</span>
        <span>金飞鹰科技以行业应用系统开发为主的高科技软件企业</span>
      </div>
    </div>
    <div class="third_box">
        <div class="w120">
            <div class="one">
              <div class="core_top">
                <span>服务器</span>
                <img src="@/assets/nav.png" alt="">
              </div>
              <div class="box_content">
                <a :href="item.href" target="_blank" v-for="(item,index) in arr" :key="index">
                    <div class="tops">
                      <span>{{item.name}}</span>
                      <div>个人认证</div>
                    </div>
                    <span>{{item.txt}}</span>
                    <div class="bottom">
                      <span>{{item.ti}}</span>
                      <div>
                        百度云下载
                      </div>
                    </div>
                </a>
              </div>
            </div>
            <div class="one">
              <div class="core_top">
                <span>客户端</span>
                <img src="@/assets/nav.png" alt="">
              </div>
              <div class="box_content">
                <a :href="item.href" target="_blank" v-for="(item,index) in arr1" :key="index">
                    <div class="tops">
                      <span>{{item.name}}</span>
                      <div>个人认证</div>
                    </div>
                    <span>{{item.txt}}</span>
                    <div class="bottom">
                      <span>{{item.ti}}</span>
                      <div>
                        百度云下载
                      </div>
                    </div>
                </a>
                <div ></div>
              </div>
            </div>
            <div class="one">
              <div class="core_top">
                <span>自助机</span>
                <img src="@/assets/nav.png" alt="">
              </div>
              <div class="box_content">
                <a :href="item.href" target="_blank" v-for="(item,index) in arr2" :key="index">
                    <div class="tops">
                      <span>{{item.name}}</span>
                      <div>个人认证</div>
                    </div>
                    <span>{{item.txt}}</span>
                    <div class="bottom">
                      <span>{{item.ti}}</span>
                      <div>
                        百度云下载
                      </div>
                    </div>
                </a>
              </div>
            </div>
            <div class="one">
              <div class="core_top">
                <span>常用工具</span>
                <img src="@/assets/nav.png" alt="">
              </div>
              <div class="box_content">
                <a :href="item.href" target="_blank" v-for="(item,index) in arr3" :key="index">
                    <div class="tops">
                      <span>{{item.name}}</span>
                      <div>个人认证</div>
                    </div>
                    <span>{{item.txt}}</span>
                    <div class="bottom">
                      <span>{{item.ti}}</span>
                      <div>
                        百度云下载
                      </div>
                    </div>
                </a>
                <div ></div>
              </div>
            </div>
        </div>
    </div>
    <Divfooter />
  </div>
</template>
<script>
export default {
  data(){
    return{
      arr:[
        {
          name:'支付宝秘钥工具',
          txt:'用于对应用的客户端服务端之间的交互进行加密保护。'  ,
          ti:'提取码：l9uw',
          href:'https://pan.baidu.com/s/1f_6s1s5Z5guDwnA6N-x0dQ?pwd=l9uw'
        },
        {
          name:'青蛙数据库工具',
          txt:'青蛙云-服务器托管，能够有效降低维护费用和机房设备投入、线路租用等高额费用。',
          ti:'提取码：o6wj',
          href:'https://pan.baidu.com/s/1v4AHjK27z-ROU269-OvhbA?pwd=o6wj'
        },
        {
          name:'微软运行库',
          txt:'专门解决运行库缺失/故障的软件，一键安装，自动修复。',
          ti:'提取码：x0xz',
          href:'https://pan.baidu.com/s/1w4RShG2cnAvOX1zCpiJjvQ?pwd=x0xz'
        },
        {
          name:'指纹仪驱动',
          txt:'识别指纹信号并将其转换成计算机能够识别的信号。',
          ti:'提取码：1r35',
          href:'https://pan.baidu.com/s/1KrHHurAgpZ_bep5uWN_gVw?pwd=1r35'
        },
        {
          name:'Jre环境',
          txt:'Java运行环境是一个软件，由太阳微系统所研发，可以让计算机系统运行Java应用程序。',
          ti:'提取码：oa9c',
          href:'https://pan.baidu.com/s/1S4oW1vsrmxZRrpZUjfR86g?pwd=oa9c'
        },
        {
          name:'身份证驱动',
          txt:'分离式身份证阅读设备打造的驱动工具。',
          ti:'提取码：q37j',
          href:'https://pan.baidu.com/s/1eD3AO8Drrtg5FLNPfO3JuQ?pwd=q37j'
        },
        {
          name:'服务端日志文件',
          txt:'是一个或多个由服务器自动创建和维护的日志文件，其中包含其所执行活动的列表。',
          ti:'提取码：18pd',
          href:'https://pan.baidu.com/s/1uMwt9dhf31H_2Bs3JmGswA?pwd=18pd'
        },
        {
          name:'自助机发卡器驱动',
          txt:'操作系统通过这个驱动接口，控制自助机设备工作。',
          ti:'提取码：rpfl',
          href:'https://pan.baidu.com/s/1NH6aBoyXQ7FfNok4vMOdqw?pwd=rpfl'
        },
        {
          name:'Win激活管理员',
          txt:'在系统上登录ID,可用于通过安装软件/应用补丁/管理用户/启动和停止服务等来管理系统。',
          ti:'提取码：8d32',
          href:'https://pan.baidu.com/s/1Xui0oDiXTrefFR-DmKj9Vg?pwd=8d32'
        },
        {
          name:'ORACLE数据库',
          txt:'适用于大型、中型和微型计算机的关系数据库管理。',
          ti:'提取码：ves1',
          href:'https://pan.baidu.com/s/1FaKWOKJoMwbW3QhoijHcUQ?pwd=ves1'
        },
        {
          name:'IP诊断工具',
          txt:'用于IP逻辑链路的测试和追踪，从而判断网络是否畅通,以及可能发生故障的位置与设备。',
          ti:'提取码：1ylj',
          href:'https://pan.baidu.com/s/1FcgoiRJZ6zi9cOPLK9N0lA?pwd=1ylj'
        },
        {
          name:'数据库语句升级',
          txt:'数据库语句是指在关系型数据库中用来完成数据操作的命令。',
          ti:'提取码：9dn5',
          href:'https://pan.baidu.com/s/1ThbC5jzvsc_djZCG_Fh-8g?pwd=9dn5'
        },
        {
          name:'2016版门禁控制工具',
          txt:'用于管理门禁系统的电子设备，它通过收集并处理信号,控制门的开启和关闭。',
          ti:'提取码：hnk5',
          href:'https://pan.baidu.com/s/1v2QqBmh7ct0fJVG4aNyxlg?pwd=hnk5'
        },
        {
          name:'.NET 4.7.2',
          txt:'帮助快速定位和解决问题，提高代码的质量和性能。',
          ti:'提取码：j2m6',
          href:'https://pan.baidu.com/s/15TdFUt3SYV5TprNA1wleUQ?pwd=j2m6'
        },
        {
          name:'.NET 4.6.2',
          txt:'帮助快速定位和解决问题，提高代码的质量和性能。',
          ti:'提取码：wv88',
          href:'https://pan.baidu.com/s/1jLV22PEXA0v6YaKpGQvrqw?pwd=wv88'
        },
        {
          name:'Redis',
          txt:'是开源的内存数据结构存储系统，主要用作数据库、缓存和消息代理。',
          ti:'提取码：w0qp',
          href:'https://pan.baidu.com/s/1g4x53gXnUiMzc8fD3nfatw?pwd=w0qp'
        }
      ],
      arr1:[
        {
          name:'office2007',
          txt:'用于文字处理、电子表格制作、演示文稿制作以及其他办公相关的任务。'  ,
          ti:'提取码：u502',
          href:'https://pan.baidu.com/s/1TsJt-jQl_ZnZPFsfeSB8qg?pwd=u502'
        },
        {
          name:'80打印模板',
          txt:'主要功能是让表单数据在打印时,按照使用中的模版格式打印。',
          ti:'提取码：xkw2',
          href:'https://pan.baidu.com/s/1X_ZJIjq0V_ecG_eQnyW3og?pwd=xkw2'
        },
        {
          name:'WPS',
          txt:'主要用于处理文字、表格、演示等办公任务。'  ,
          ti:'提取码：ul40',
          href:'https://pan.baidu.com/s/1qIP34VhkEr26rK9F4oCe4g?pwd=ul40'
        },
        {
          name:'02U读卡器驱动',
          txt:'连接读卡器和电脑之间的桥梁，能够启动读卡器设备并传输数据。'  ,
          ti:'提取码：92r4',
          href:'https://pan.baidu.com/s/1hCkIMUpLMb9jcttyrGb5jw?pwd=92r4'
        },
        {
          name:'08U读卡器驱动',
          txt:'是连接读卡器和电脑之间的桥梁，能够启动读卡器设备并传输数据。'  ,
          ti:'提取码：vxik',
          href:'https://pan.baidu.com/s/1dxy-1_RR6ErhUeXSgMH2lg?pwd=vxik'
        },
        {
          name:'BTP-R588热敏打印机驱动',
          txt:'连接打印机与电脑的纽带可以将需要打印的文件从计算机上转化为打印机能够识别的语言。'  ,
          ti:'提取码：3ba4',
          href:'https://pan.baidu.com/s/10CM7Jra0CjAnSyYbgEdz-w?pwd=3ba4'
        },
        // {
        //   name:'服务端、客户端文档',
        //   txt:'服务端、客户端文档'  ,
        //   ti:'提取码：xfrp',
        //   href:'https://pan.baidu.com/s/1Ew2i9xXlAqklVGSh8EFWkw?pwd=xfrp'
        // },
        // {
        //   name:'金飞鹰内管系统常见问题2019',
        //   txt:'金飞鹰内管系统常见问题'  ,
        //   ti:'提取码：3b4x',
        //   href:'https://pan.baidu.com/s/1zqBeSpdxF-GHImZMDX0m9A?pwd=3b4x'
        // },
        // {
        //   name:'2024-金飞鹰雪务通系统常见问题',
        //   txt:'2024-金飞鹰雪务通系统常见问题'  ,
        //   ti:'提取码：173i',
        //   href:'https://pan.baidu.com/s/1Irf6wq2mIVxupV3cudR2uw?pwd=173i'
        // },
        // {
        //   name:'2023培训内容',
        //   txt:'2023培训内容'  ,
        //   ti:'提取码：jsyr',
        //   href:'https://pan.baidu.com/s/1DEmtiRluSiHMBg_gb2rs1A?pwd=jsyr'
        // },
        // {
        //   name:'2019金飞鹰硬件产品',
        //   txt:'2019金飞鹰硬件产品'  ,
        //   ti:'提取码：bz0g',
        //   href:'https://pan.baidu.com/s/1GIQ9GycncyWg0udjjj50_w?pwd=bz0g'
        // },
      ],
      arr2:[
        {
          name:'K7X0发卡器驱动 ',
          txt:'可以进行读卡、写卡、授权、格式化等操作。'  ,
          ti:'提取码：u502',
          href:'https://pan.baidu.com/s/1iSKbUu9G77MAg7xMV4Vt5w?pwd=u502'
        },
        {
          name:'自助机广告屏驱动',
          txt:'用来调制显示器件的相位、峰值、频率等建立驱动电场，实现液晶显示期间的显示效果。'  ,
          ti:'提取码：xkw2',
          href:'https://pan.baidu.com/s/1pKKOOGrJ-KUqYUDkQYMIHw?pwd=xkw2'
        },
        {
          name:'自助机发卡器驱动',
          txt:'可以进行读卡、写卡、授权、格式化等操作。'  ,
          ti:'提取码：ul40',
          href:'https://pan.baidu.com/s/1NH6aBoyXQ7FfNok4vMOdqw?pwd=ul40'
        }
      ],
      arr3:[
        {
          name:'输入法',
          txt:'搜狗输入法支持多种输入方式，包括拼音、手写、语音等，能够满足不同用户的需求。'  ,
          ti:'提取码：s6mc',
          href:'https://pan.baidu.com/s/1ITpTsi0AuE-4mtQnvVYs9Q?pwd=s6mc'
        },
        {
          name:'录屏软件',
          txt:'可录制分辨率高达3840×2160高画质视频，可支持bmp、png、jpeg格式截图。'  ,
          ti:'提取码：mk3f',
          href:'https://pan.baidu.com/s/1VEe2gyJkqZxJ_SNtJgBHHg?pwd=mk3f'
        },
        {
          name:'QQ',
          txt:'在线聊天、视频通话、语音聊天、点对点断点续传文件、共享文件、QQ邮箱等多种功能。 '  ,
          ti:'提取码：877q',
          href:'https://pan.baidu.com/s/1t_JCVSbzxA3uRJHqVYvVFw?pwd=877q'
        },
        {
          name:'压缩解压工具',
          txt:'支持多种格式解压。'  ,
          ti:'提取码：ckhg',
          href:'https://pan.baidu.com/s/1Yp1uyVbJpWuU_QD6ngoQrA?pwd=ckhg'
        },
        {
          name:'向日葵远程工具',
          txt:'向日葵远程工具主要用于远程PC管理和控制服务，支持跨平台操作。'  ,
          ti:'提取码：czc3',
          href:'https://pan.baidu.com/s/1DuGHjHY5ereMKW1l4CLu0w?pwd=czc3'
        },
        {
          name:'浏览器',
          txt:'搜狗浏览器提供一个跨终端的使用体验，简化上网操作，提供流畅的网页阅读体验。'  ,
          ti:'提取码：toj4',
          href:'https://pan.baidu.com/s/1wvKkiUFTP3lf-DXMN6jaLw?pwd=toj4'
        },
        {
          name:'花生壳',
          txt:'支持在客户端上添加端口映射，快速将内网服务发布到外网。'  ,
          ti:'提取码：a5g7',
          href:'https://pan.baidu.com/s/1IDTA-obLQxYa0EcjII_oGg?pwd=a5g7'
        },
        {
          name:'微信',
          txt:'免费应用程序，提供即时通讯服务。'  ,
          ti:'提取码：z6u2',
          href:'https://pan.baidu.com/s/18kgO9JhzOG9xLcOJimk0AQ?pwd=z6u2'
        },
        
      ]
    }
  }
}
</script>
<style lang="less" scoped>
.main{
  width: 100%;
  .top_back{
    width: 100%;
    height: 42.8rem;
    background: url(../../assets/black.png) no-repeat;
    background-size: 100% 100%;
  }
  .bj_box{
    padding: 19.3rem 0 0 0;
    box-sizing: border-box;
    >span{
      color: #fff;
      font-size: 4.6rem;
      &:nth-child(2){
        display: block;
        margin-top: 1.6rem;
        font-size: 1.6rem;
      }
    }
  }
  .third_box{
    padding: 9.4rem 0 10rem 0;
    box-sizing: border-box;
    background: #F6F9FC;
    .one{
      margin-top: 10rem;
      &:nth-child(1){
        margin-top: 0;
      }
      .core_top{
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          span{
            font-size: 3.6rem;
            color: #333B47;
          }
          img{
            width: 3.27rem;
            height: 1.169rem;
            margin-top: .7rem;
          }
      }
      .box_content{
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-top: 6rem;
        >a{
          width: 39rem;
          height: 20rem;
          background: #FFFFFF;
          margin-bottom: 1.5rem;
          display: flex;
          flex-direction: column;
          padding: 3rem;
          box-sizing: border-box;
          >span{
            color: #999999;
            font-size: 1.6rem;
            display: block;
            margin-top: 1.5rem;
          }
          .tops{
            display: flex;
            justify-content: space-between;
            >span{
              color: #333333;
              font-size: 2rem;
              font-weight: 600;
            }
            >div{
              width: 6rem;
              height: 2rem;
              color: #E86F00;
              background: #FFF0C5;
              font-size: 1.2rem;
              border-radius: 0.4rem;
              display: flex;
              justify-content: center;
              align-items: center;
            }
          }
          .bottom{
            display: flex;
            justify-content: space-between;
            margin-top: auto;
            align-items: center;
            span{
              color: #999999;
              font-size: 1.6rem;
            }
            div{
              width: 14rem;
              height: 3.8rem;
              border: 1px solid #E86F00;
              display: flex;
              justify-content: center;
              align-items: center;
              color: #E86F00;
              font-size: 1.6rem;
            }
          }
        }
        >div{
          width: 39rem;
          height: 20rem;
        }
      }
    }
  }
}
</style>